import(/* webpackMode: "eager" */ "/vercel/path0/Website/app/(home)/discover/search/search-page-client.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/Website/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js")